import React from 'react';
import '../Homepage/Homepage.scss';
import '../../resources/main.scss'
import benefitsJson from './benefits.json'
import "yet-another-react-lightbox/styles.css";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import ReactPlayer from 'react-player';
import { clientsService } from "../../services/ClientsService";
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../constants/NotificationSystemStyle';
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, withRouter } from 'react-router-dom'
import ModalVideo from 'react-modal-video'
import VideoModal from '../../components/VideoModal/VideoModal';

class Homepage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            videoPlaying: true,
            contactInfo: {
                name: '',
                phone: '',
                message: '',
                email: ''
            },
            benefits: benefitsJson,
            openedSlider: false,
            selectedItem: [],
            topVisible: true,
            isModalOpen: false,
            isVideoMute: false
        }
        this.notificationSystem = React.createRef();
    }
    componentDidMount() {
        this.timerHandle = setTimeout(() => {
          this.setState({ videoPlaying: false });
        }, 1000);
      }
    toggleTop = () => {
        let topVisible = this.state.topVisible;
        topVisible = !topVisible;
        this.setState({ topVisible })
    }
    updateField = event => {
        event.preventDefault()
        const field = event.target.name;
        let contactInfo = { ...this.state.contactInfo };
        contactInfo[field] = event.target.value;
        this.setState({ contactInfo })
    }
    openSlider = (selectedBenefitPhotos) => {
        let openedSlider = this.state.openedSlider;
        openedSlider = true;
        let selectedItem = { ...this.state.selectedItem };
        selectedItem = selectedBenefitPhotos;
        this.setState({ selectedItem }, () => { console.log(this.state.selectedItem.map(item => item.photoUrl)) })
        this.setState({ openedSlider })
    }
    closeSlider = () => {
        console.log('vlogrfhg')
        let openedSlider = this.state.openedSlider;
        openedSlider = false;
        this.setState({ openedSlider })
    }
    toggleVideo = () => {
        let videoPlaying = this.state.videoPlaying;
        videoPlaying = !videoPlaying;
        this.setState({ videoPlaying })
    }
    toggleModalVideo = () => {
      console.log('here');
        let isModalOpen = this.state.isModalOpen;
        let isVideoMute = this.state.isVideoMute;
        isVideoMute = !isVideoMute;
        this.setState({ isVideoMute })
        isModalOpen = !isModalOpen;
        this.setState({ isModalOpen })
    }
    handleSubmit = event => {
        event.preventDefault();
        const notification = this.notificationSystem.current;
        clientsService.createOrUpdate(this.state.contactInfo).then(response => {
            notification.addNotification({
                message: 'Mesajul a fost trimis cu success.',
                level: 'success',
                position: 'tc'
            });
        })
            .catch(err => {
                notification.addNotification({
                    message:
                        'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
                    level: 'error',
                    position: 'tc'
                });
            })
    }
    scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // This creates the smooth scrolling effect
        });
      };

    componentWillUnmount() {
      if (this.timerHandle) {
          clearTimeout(this.timerHandle);
          this.timerHandle = 0;
      }
    }

    render() {
        return (
            <div className='standard homepage'>
                <div className='homepage__top-wrapper'>
                    {this.state.topVisible ? <div className='homepage__top'>
                        <a href={`tel:0758952952`} className='standard__link' >
                            <div className='homepage__call'>
                                <img src='/images/call.png' alt='phone' className='homepage__call' />
                                <h5 className='homepage__phone'>0758952952</h5>
                            </div>
                        </a>

                        <a
                            className='standard__link'
                            href={`https://www.facebook.com/profile.php?id=100093559512783`} target="_blank"
                            rel="noopener noreferrer"><div className='homepage__social-top'>
                                <img src='/images/facebook-white.png' alt='facebook' />
                            </div></a>


                    </div> : ''}
                    <img src={this.state.topVisible ? '/images/up.png' : '/images/contact.png'} alt='close' className={this.state.topVisible ? 'homepage__close' : 'homepage__contact'} onClick={this.toggleTop} />
                </div>
                <div className='homepage__banner homepage__player-wrapper'>
                    <ReactPlayer
                        className='homepage__react-player'
                        url='/videos/video-cabana-scurt.mp4'
                        width='100%'
                        height='100%'
                        objectfit='cover'
                        playing={!this.state.videoPlaying}
                        loop={true}
                        muted={true}
                        allow='autoplay; encrypted-media'
                        maxwidth='300px'
                        allowFullScreen={true}
                        onClick={this.toggleVideo}
                        playsinline={true}
                    />
                    <img src='/images/logo.png' alt='logo' className='homepage__logo' />
                    <h2 className='homepage__title-name'>Pensiunea Poiana Putna</h2>
                    <ScrollLink to="info" duration={800} smooth={true} className='standard__link homepage__link'> <button className='homepage__call-action'>AFLĂ MAI MULTE</button></ScrollLink>
                </div>
                <div className='homepage__motto'>
                    <h2>Bine ați venit la Pensiunea Poiana Putna - locul perfect pentru o evadare relaxantă în mijlocul naturii!</h2>
                    <div className='homepage__line' />
                    <h3 className='homepage__invitation'>Vă invităm să descoperiți frumusețea pură a Poianei Putna, unde se află Pensiunea noastră.</h3><h3 className='homepage__invitation'> Situată într-un cadru pitoresc, înconjurată de păduri și munți, veți găsi liniște și armonie în mijlocul naturii autentice.</h3>
                    <h4 className="homepage__see-video" onClick={this.toggleModalVideo}>Vrei să vezi mai mult?</h4>

                <RouterLink to='/meniu' className='standard__link'>
                    <div className='homepage__sticky-menu'>
                   <h4>Vezi meniul</h4>
                </div>
                </RouterLink>
                </div>

                <div className='homepage__benefits-section'>
                    <h3 className='homepage__subtitle'>Ce vă putem oferi</h3>
                    <div className='homepage__benefits'>
                        {this.state.benefits.map(benefit => (
                            <div className='homepage__single-benefit' key={benefit.id}>
                                <img src={benefit.icon} alt='beneficiu' className='homepage__benefit-img' onClick={() => this.openSlider(benefit.photos)} />
                                <h3 className='homepage__benefit-title'>
                                    {benefit.name}
                                </h3>
                                <p className='homepage__benefit-description'>
                                    {benefit.description}
                                </p>
                                {benefit.name==='Restaurant'? <RouterLink to='/meniu'className='standard__link'><button className='homepage__see-menu' onClick={this.scrollToTop}>Meniu</button></RouterLink>:''}
                                <button className='homepage__see-benefit' onClick={() => this.openSlider(benefit.photos)}>Vezi mai mult</button>
                            </div>

                        ))}
                    </div>
                    <Lightbox
                        open={this.state.openedSlider}
                        close={() => this.closeSlider()}
                        slides={this.state.selectedItem}
                        plugins={[Thumbnails, Slideshow, Zoom]}
                    />
                </div>

                <div className='homepage__contact-section' id="info">
                    <h3 className='homepage__subtitle homepage__contact-subtitle'>Contactează-ne</h3>
                    <div className='homepage__line' />
                    <form className='homepage__form' onSubmit={this.handleSubmit}>
                        <div className='homepage__input-box homepage__small-field'>
                            <h3 className='homepage__label'>Nume:</h3>
                            <input
                                className="homepage__field"
                                type="text"
                                name="name"
                                required
                                onChange={this.updateField}
                                value={this.state.contactInfo.name}
                            />
                        </div>

                        <div className='homepage__input-box homepage__small-field'>
                            <h3 className='homepage__label'>Număr de telefon:</h3>
                            <input
                                className="homepage__field"
                                type="number"
                                name="phone"
                                required
                                onChange={this.updateField}
                                value={this.state.contactInfo.phone}
                            />
                        </div>
                        <div className='homepage__input-box homepage__small-field'>
                            <h3 className='homepage__label'>Email</h3>
                            <input
                                className="homepage__field"
                                type="email"
                                name="email"
                                onChange={this.updateField}
                                value={this.state.contactInfo.email}
                            />
                        </div>
                        <div className='homepage__input-box homepage__small-field'>
                            <h3 className='homepage__label'>Mesaj:</h3>
                            <textarea
                                rows='5'
                                columns='5'
                                className="homepage__field homepage__textarea"
                                type="text"
                                name="message"
                                required
                                onChange={this.updateField}
                                value={this.state.contactInfo.message}
                            />
                        </div>
                        <button className='homepage__call-action homepage__submit homepage__see-benefit' type='submit'>Trimite mesajul</button>
                    </form>
                </div>

                <div className='homepage__footer'>
                    <img src='/images/logo.png' alt='logo' className='homepage__footer-logo' />
                    <h5 className='homepage__footer-contact'>0758952952</h5>
                    <h5 className='homepage__footer-contact'>poianaputna@gmail.com</h5>
                    <h5 className='homepage__footer-contact'>Str. Partiei, Putna, Suceava</h5>
                    <div className='homepage__social-box'>
                        <a
                            className='standard__link'
                            href={`https://www.facebook.com/profile.php?id=100093559512783`} target="_blank"
                            rel="noopener noreferrer">  <img src='/images/facebook.png' alt='facebook' /></a>
                             <a
                            className='standard__link'
                            href={`https://www.instagram.com/pensiuneapoianaputna/?igshid=OGQ5ZDc2ODk2ZA%3D%3D`} target="_blank"
                            rel="noopener noreferrer">  <img src='/images/instagram.png' alt='instagram' /></a>
                         <a
                            className='standard__link'
                            href={`https://api.whatsapp.com/send?phone=0758952952`} target="_blank"
                            rel="noopener noreferrer">   <img src='/images/whatsapp.png' alt='whatsapp' /></a>
                    </div>
                </div>
                { this.state.isModalOpen && <VideoModal
                    url="/videos/video-cabana-lung.mp4"
                     modalIsOpen={this.state.isModalOpen}
                     closeModal={this.toggleModalVideo}
               /> }
                <NotificationSystem
                    ref={this.notificationSystem}
                    style={NotificationSystemStyle}
                />
            </div>
        )
    }
}
export default withRouter(Homepage);
